import React from 'react';
import PropTypes from 'prop-types';
import styles from './ActiveShares.module.scss';
import X from '../../../../assets/svg/Feather/X';

const Grantee = (props) => {
  if (props.share.user) {
    const setUserIcon = (user) => user.firstName.charAt(0)
    return (
      <div className={styles.grantee}>
        <div className={styles.user}>
          {props.share.user.avatar ? <img className={styles.avatar} src={props.share.user.avatar }/> : <i className={styles.icon}>{setUserIcon(props.share.user)}</i>}
          <p>{props.share.user.firstName} {props.share.user.lastName}</p>
        </div>
        <div className={styles.close} onClick={props.openRescindShareModal(props.share.rescindUrl)}>
          <X width={14} color='#fff' />
        </div>
      </div>
    );
  }
};

Grantee.propTypes = {
  share: PropTypes.object,
  openRescindShareModal: PropTypes.func,
};
function ActiveShares(props) {
  return (
    <>
      { props.shares.length > 0 ?
        <div className={styles.container}>
          {props.shares.map((share) => {
            if (share.user) {
              return (
                <Grantee
                  key={share.user.uuid}
                  openRescindShareModal={props.openRescindShareModal}
                  rescindShare={props.rescindShare}
                  share={share}
                />
              );
            }
          })}
        </div> : null
      }
    </>
  );
}

ActiveShares.propTypes = {
  shares: PropTypes.any,
  rescindShare: PropTypes.func,
  openRescindShareModal: PropTypes.func
};

export default ActiveShares